import React, { useState, useRef } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import PublishIcon from '@material-ui/icons/Publish';
import DialogHeader from 'components/DialogHeader/DialogHeader';

import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';
import { getErrorMessageKey } from 'helpers/helpers';
import { EdwardColors } from 'enums';

interface OwnProps {
  name: string;
  onChange?: Function;
  upload?: () => void;
  multiple?: boolean;
  accept?: string;
  specificError?: boolean;
  errors?: any;
  vertical?: boolean;
  disabled?: boolean;
  noFileName?: boolean;
  accepted?: string;
}

type Props = OwnProps;

const FileUpload: React.FC<Props> = ({
  onChange,
  upload,
  multiple,
  accept,
  name,
  specificError,
  errors,
  vertical,
  disabled,
  noFileName,
  accepted,
}) => {
  const [files, setFiles] = useState<null | File[]>();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();
  let error = null;
  const path = name.split('.');
  if (errors && Object.keys(errors).length) {
    if (path.length === 1) error = errors[path[0]];
    if (path.length === 2 && errors[path[0]]) error = errors[path[0]][path[1]];
  }

  const errorMessage = error ? t(getErrorMessageKey(error, specificError)) : '';

  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Box display="flex" style={vertical ? { flexDirection: 'column' } : undefined}>
      <Button
        variant={'contained'}
        component="label"
        style={vertical ? { maxWidth: '200px' } : undefined}
        disabled={disabled}
      >
        {t('form_fileUpload_btn')}
        <input
          ref={inputRef}
          name={name}
          type="file"
          style={{ display: 'none' }}
          multiple={!!multiple}
          accept={accept}
          onChange={(e) => {
            const files = e.target.files ? Object.values(e.target.files) : null;
            setFiles(files);
            files && !noFileName && setDialogOpen(true);
            onChange && onChange(e);
          }}
          disabled={disabled}
        />
      </Button>
      {!noFileName && (
        <Box
          ml={2}
          display={vertical ? 'block' : 'flex'}
          alignItems="center"
          style={vertical ? { padding: '20px 0', margin: 0, fontSize: '80%' } : { fontSize: '80%' }}
        >
          {errorMessage && (
            <>
              <br />
              <strong style={{ color: 'red' }}>{errorMessage}</strong>
            </>
          )}
        </Box>
      )}
      {upload && (
        <Dialog open={dialogOpen} maxWidth={'sm'} fullWidth>
          <DialogHeader onClose={() => setDialogOpen(false)}>{t('form_fileUpload_title')}</DialogHeader>
          <DialogContent>
            <DialogContentText align="left">
              {accepted && <Typography>{accepted}</Typography>}
              {t('form_fileUpload_selected')}:{' '}
              {files && (
                <strong style={{ fontSize: '19px', color: EdwardColors.SECONDARY }}>
                  {files.map((file) => ` ${file.name}`)}
                </strong>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                inputRef.current && inputRef.current.click();
              }}
              color="default"
              variant="contained"
            >
              {t('form_fileUpload_another')}
            </Button>
            <Button
              onClick={() => { setDialogOpen(false); upload(); }}
              startIcon={<PublishIcon />}
            >
              {t('form_fileUpload_upload')}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default FileUpload;
